/**
 *
 * Post Search
 *
 * UI that handles the post search feature on the blog page (and anywhere else)
 */

const $ = require('jQuery')

class PostSearch {
  constructor (el) {
    this.$el = $(el)
    this.$form = this.$el.find('#post-search')
    this.$input = this.$el.find('.itbl-b-searchbox__input')
    this.$submit = this.$el.find('.itbl-b-searchbox__submit')
    this.$spinner = this.$el.find('.itbl-b-post-search__loading')

    this.getQuery = this.getQuery.bind(this)
    this.search = this.search.bind(this)

    this.$form.off('submit')
    this.$form.on('submit', this.search)
  }

  getQuery () {
    const query = this.$input
      .val()
      .replace(/[^a-zA-Z0-9 -'.,@:]/g, "")

    return query
  }

  search (e) {
    e.preventDefault()

    this.$spinner.removeClass('hide')
    this.$form.addClass('hide')

    let query = this.getQuery(e)
    query = encodeURIComponent(query)

    let url = (window.ITBL && window.ITBL.site_url) ? window.ITBL.site_url : ''
    url = url.replace(/\/$/, '')
    url = `${url}/blog/?q=${query}`

    window.location.href = url
  }
}

$(document).ready(() => {
  $('#itbl-post-search').each(function(){
    new PostSearch(this)
  })
})
